
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as homemVQE8cA5_45fDoJ3rJeKbFyVzMpJ8tWTfp8tsZFcDUUYIMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/home.vue?macro=true";
import { default as testFqtKjnYkA739t2W3vK5DWzfQ0TpmWofDXP4zHCgp0EAMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/test.vue?macro=true";
import { default as storeOaolWqdWxlyAAEaF1TTD3eElym_45HH6SA36BCssyJEVAMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/store.vue?macro=true";
import { default as app_45storevGGdaHN_t_45s4gVNdiKCShsXzbbTFf1TU9SYd3FN8oMMMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/app-store.vue?macro=true";
import { default as attendanceWrJIvUx5tRhWp8waLfa7x7pmH9Qle1QwecPSBhPowxoMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/attendance.vue?macro=true";
import { default as event_45listD6mTgIR1B7SGis__45tYB_nthXyiSDgF4ACy2ufaMMaWAMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event-list.vue?macro=true";
import { default as event_45testuB6F_Gaex1RsW4Ea0QO3vxgR1W2HTzluFz0mRdmrVNgMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event-test.vue?macro=true";
import { default as your_45emotionsoCvoZ0JHYkSJj1ZPIW6FTE4l0ILnxM3IcFTiYEnc7i8Meta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/your-emotions.vue?macro=true";
import { default as end_45event_45list1C8_45_lhVpPJ1ArDFUSh_45AA_45dmMa1C3qlqwAPwammsucMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/end-event-list.vue?macro=true";
import { default as PLKEY_4514PugmN85npPAQFdKjsc_45kh1iSr6aofN4MevJ14prniW0Meta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/PLKEY-14.vue?macro=true";
import { default as PLKEY_45159XP3SpsyM454uDi3aYVK1v7PItxp4s_b8QEWcwB9IH8Meta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/PLKEY-15.vue?macro=true";
import { default as PLKEY_4517WsZI_45OqR7hK0zfVs6eYaSMdvEoLI_45Ny4gPS7BgnAOm0Meta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/PLKEY-17.vue?macro=true";
import { default as theme_45selectorX5trmisNUNq7KdEPmlYVbiU6JqNCS1d5oAFSF85_45UN4Meta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/theme-selector.vue?macro=true";
import { default as _91eventId_93pn9fv8MLGNnJscMbR2LrYfnx1czgVjcNOs73LyW9g3MMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/[eventId].vue?macro=true";
import { default as BLUE_45ARCHIVEi1oPzTSV1y9WTVXyPKCJ5wjsenXWA0I_45ewPNYrbny0oMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/BLUE-ARCHIVE.vue?macro=true";
import { default as WHATS_NEW_45GT4q91yunG7DxF_454wm3HH09sX1PkZJg4DxqqWOQOJNLpzYMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/WHATS_NEW-GT4.vue?macro=true";
import { default as GUARDIAN_TALESdxyTTPxztN5b6kXT09JWsCxaMOB6GC6TNuxt_45sOnzxQMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/GUARDIAN_TALES.vue?macro=true";
import { default as GUARDIAN_45TALESDoAgbtfmSJbfVGpRiELBJfHL26ppXJHoa6ciWUB92CgMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/GUARDIAN-TALES.vue?macro=true";
import { default as PRICONNE_45THEME5c8_Wv1R0wWxuyDPY8JmryC_mpA066yaxQY3EtB92cUMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/PRICONNE-THEME.vue?macro=true";
import { default as WHATS_NEW_45GT4_45ENkRPZr61ouOTo4EUjzhgmODP3O4GFqYqwKtuWF6FKNQkMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/WHATS_NEW-GT4-EN.vue?macro=true";
import { default as WHATS_NEW_45PRICONNEctVOf84ieMAMNHd0d6sM4rGq9U1wohR2qInARE4eEnYMeta } from "/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/WHATS_NEW-PRICONNE.vue?macro=true";
export default [
  {
    name: "home",
    path: "/home",
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/home.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/test.vue")
  },
  {
    name: "store",
    path: "/store",
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/store.vue")
  },
  {
    name: "app-store",
    path: "/app-store",
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/app-store.vue")
  },
  {
    name: "attendance",
    path: "/attendance",
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/attendance.vue")
  },
  {
    name: "event-list",
    path: "/event-list",
    meta: event_45listD6mTgIR1B7SGis__45tYB_nthXyiSDgF4ACy2ufaMMaWAMeta || {},
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event-list.vue")
  },
  {
    name: "event-test",
    path: "/event-test",
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event-test.vue")
  },
  {
    name: "your-emotions",
    path: "/your-emotions",
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/your-emotions.vue")
  },
  {
    name: "end-event-list",
    path: "/end-event-list",
    meta: end_45event_45list1C8_45_lhVpPJ1ArDFUSh_45AA_45dmMa1C3qlqwAPwammsucMeta || {},
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/end-event-list.vue")
  },
  {
    name: "event-PLKEY-14",
    path: "/event/PLKEY-14",
    meta: PLKEY_4514PugmN85npPAQFdKjsc_45kh1iSr6aofN4MevJ14prniW0Meta || {},
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/PLKEY-14.vue")
  },
  {
    name: "event-PLKEY-15",
    path: "/event/PLKEY-15",
    meta: PLKEY_45159XP3SpsyM454uDi3aYVK1v7PItxp4s_b8QEWcwB9IH8Meta || {},
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/PLKEY-15.vue")
  },
  {
    name: "event-PLKEY-17",
    path: "/event/PLKEY-17",
    meta: PLKEY_4517WsZI_45OqR7hK0zfVs6eYaSMdvEoLI_45Ny4gPS7BgnAOm0Meta || {},
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/PLKEY-17.vue")
  },
  {
    name: "theme-selector",
    path: "/theme-selector",
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/theme-selector.vue")
  },
  {
    name: "event-eventId",
    path: "/event/:eventId()",
    meta: _91eventId_93pn9fv8MLGNnJscMbR2LrYfnx1czgVjcNOs73LyW9g3MMeta || {},
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/[eventId].vue")
  },
  {
    name: "event-BLUE-ARCHIVE",
    path: "/event/BLUE-ARCHIVE",
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/BLUE-ARCHIVE.vue")
  },
  {
    name: "event-WHATS_NEW-GT4",
    path: "/event/WHATS_NEW-GT4",
    meta: WHATS_NEW_45GT4q91yunG7DxF_454wm3HH09sX1PkZJg4DxqqWOQOJNLpzYMeta || {},
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/WHATS_NEW-GT4.vue")
  },
  {
    name: "event-GUARDIAN_TALES",
    path: "/event/GUARDIAN_TALES",
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/GUARDIAN_TALES.vue")
  },
  {
    name: "event-GUARDIAN-TALES",
    path: "/event/GUARDIAN-TALES",
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/GUARDIAN-TALES.vue")
  },
  {
    name: "event-PRICONNE-THEME",
    path: "/event/PRICONNE-THEME",
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/PRICONNE-THEME.vue")
  },
  {
    name: "event-WHATS_NEW-GT4-EN",
    path: "/event/WHATS_NEW-GT4-EN",
    meta: WHATS_NEW_45GT4_45ENkRPZr61ouOTo4EUjzhgmODP3O4GFqYqwKtuWF6FKNQkMeta || {},
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/WHATS_NEW-GT4-EN.vue")
  },
  {
    name: "event-WHATS_NEW-PRICONNE",
    path: "/event/WHATS_NEW-PRICONNE",
    meta: WHATS_NEW_45PRICONNEctVOf84ieMAMNHd0d6sM4rGq9U1wohR2qInARE4eEnYMeta || {},
    component: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/pages/event/WHATS_NEW-PRICONNE.vue")
  }
]